import React from 'react'
import "./featured.css"
import FeaturedProducts from './FeaturedProducts/FeaturedProducts'

function Featured({products, title}: any) {
  const featuredProducts = products?.data?.slice(0, 8);
  return (
    <div id='sectionToScrollTo' className='hd-container'>
      <div className="sec-heading">{title}</div>
      <div className="hd-products">
        {featuredProducts?.map((item: any)  => (
          <FeaturedProducts key={item.id} id={item.id} data={item.attributes} />
        ))}
      </div>
    </div>
  )
}

export default Featured
